import tw, { styled } from 'twin.macro';

const Tag = styled.span(() => [
  tw`rounded-none	inline-block bg-gray-200
  px-3 py-1 text-sm
  font-semibold text-black
`,
]);

export default Tag;
